import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';

import { rem, media } from '../../../core';

const modifiers = {
  xLarge: ({ theme }) => ({
    styles: `
      font-size: ${theme.heading.xLarge};
      font-weight: 700;
      letter-spacing: 0.12px;
    `,
  }),

  medium: ({ theme }) => ({
    styles: `
      font-size: ${theme.heading.medium};
      font-weight: 700;
      letter-spacing: 0.12px;
    `,
  }),

  small: ({ theme }) => ({
    styles: `
      font-size: font-size: ${theme.heading.small};
      font-weight: 700;
      letter-spacing: 0.12px;
    `,
  }),

  xSmall: ({ theme }) => ({
    styles: `
      font-size: ${theme.heading.xSmall};
      font-weight: 700;
      letter-spacing: 0.12px;
    `,
  }),

  micro: ({ theme }) => ({
    styles: `
      font-size: ${theme.heading.micro};
      font-weight: 700;
      letter-spacing: 0.12px;
    `,
  }),

  hero: ({ theme }) => ({
    styles: `
      font-size: ${theme.heading.xLarge};
      font-weight: 700;
      letter-spacing: 0.12px;
      @media ${media.tabletMin} {
        font-size: ${rem(35)};
      }
    `,
  }),
  light: () => ({
    styles: `
      font-weight: 500;
    `,
  }),
  inverted: () => ({
    styles: `
      color: white;
    `,
  }),

};

export const TitleStyled = styled.h1.attrs({
  className: 'title',
})`
  color: #333333;
  margin: 0;
  font-family: ${(props) => props.theme.fontFamily};
  font-size: ${(props) => props.theme.heading.medium};
  ${applyStyleModifiers(modifiers)};
`;
